import { createStore } from 'vuex'
import ConfigurateurGlobal from "./ConfigurateurGlobal";

/*
import ConfigurateurCable from "./test/ConfigurateurCable";
import ConfigurateurCoA from "./test/ConfigurateurCoA";
import ConfigurateurCoB from "./test/ConfigurateurCoB";
import ConfigurateurChaussette from "./test/ConfigurateurChaussette";
*/

//import ConfigurateurPrePanier from "./test/ConfigurateurPrePanier";


import ConfigurateurCable from "./ConfigurateurCable";
import ConfigurateurCoA from "./ConfigurateurCoA";
import ConfigurateurCoB from "./ConfigurateurCoB";
import ConfigurateurChaussette from "./ConfigurateurChaussette";


import ConfigurateurPrePanier from "./ConfigurateurPrePanier";



import ConfigurateurLongueur from "./ConfigurateurLongueur";

import ConfigurateurUser from "./ConfigurateurUser";
import ConfigurateurEmailClient from "./ConfigurateurEmailClient";

export default createStore({
  modules: { 
    storeGlobal : ConfigurateurGlobal,
    storeCable : ConfigurateurCable,
    storeCoA : ConfigurateurCoA,
    storeCoB : ConfigurateurCoB,
    storeChaussette : ConfigurateurChaussette,
    storeLongueur : ConfigurateurLongueur,
    storePrePanier : ConfigurateurPrePanier,
    storeUser : ConfigurateurUser,
    storeEmailClient : ConfigurateurEmailClient
  },
})